import { render, staticRenderFns } from "./NewsBar.vue?vue&type=template&id=6a19e5e9&scoped=true&"
import script from "./NewsBar.vue?vue&type=script&lang=js&"
export * from "./NewsBar.vue?vue&type=script&lang=js&"
import style0 from "./NewsBar.vue?vue&type=style&index=0&id=6a19e5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19e5e9",
  null
  
)

export default component.exports